<template>
  <div class="max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 pt-3 pb-3 pl-2">
    <router-link
      :to="{name: 'FamiliareDetail', params: { 'id': id, 'genitore': familiare.id } }"
      class="no-underline w-full"
    >
      <div class=" flex flex-col justify-between leading-normal relative z-2">
        <div class="flex items-center">
          <img
            class="rounded-full xs:mr-2 mr-4 h-20 w-20 -mb-2 -mt-1"
            src="/img/user.png"
          >
          <div class="pr-4">
            <h4 class="text-grey-dark ">{{ familiare.name }} {{ familiare.surname }}</h4>
            <p class="text-grey-light">{{ familiare.relative }}</p>
            <div
              v-if="familiare.is_admin"
              class="text-white absolute pin-t pin-r bg-green rounded-full -mt-6 -mr-6 z-1"
              style="top: 50%"
            ><i class="fas fa-key p-3 text-2xl"></i></div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['id', 'familiare'],
  data() {
    return {};
  },
  methods: {},
};
</script>
